import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { GlobalContext } from "../../Context/GlobalState";
import { useQuery } from "../../utils/useQuery";
import { billpunchbasicauth } from "../../utils/Credentials";
import { BASE_URL_API_TRANXT_UAT_API } from "../../utils/Constant";
import { ViewExpenseTableHR } from "../Admin/Salarytable";
const arr = [{ label: "Name", value: "Name" }];
const ViewSalaryExpenseHR = () => {
  const query = useQuery();
  const id = query.get("id");

  const {user, setTransactionLoaderState } = useContext(GlobalContext);
  const [data, setData] = useState([]);
  const { password , username } = billpunchbasicauth;
 
  const CompanyName = sessionStorage.getItem("CompanyName");

  const getPropertyExpense = async (e) => {
    setTransactionLoaderState(true);
    try {
        const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        firmid:user.firm_id,
        empid: "0"
      });

      var requestOptions = {
        method: "POST",
        headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetFirmExpense`,
        requestOptions
      );
      const data = await res.json();
      if (data.status == "0") {
        setData(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
    }
    setTransactionLoaderState(false);
  };

  useEffect(() => {
    getPropertyExpense();
  }, []);

  return (
    <>
      <div className="mt-4">
        <div className=" row ">
          <h4 className="col  d-flex align-items-center ">
            {" "}
            {user.organisation} Expenses List
          </h4>

          <div className=" col-2 mr-md-4 mr-sm-3 d-flex justify-content-end">
            {" "}
            <Link to={"/Hr/ExpenseManagement"} style={{textDecoration:"none"}}>
              <button
                type="button"
                className="btn btn-sm justify-content-center align-items-center"
                style={{
                  background: "#2ca01c",
                  borderRadius: ".4em",
                  height: "2.5em",
                  // width: "8rem",
                  border: "None",
                  color: "#fff",
                }}
              >
                Back
              </button>
            </Link>
          </div>
        </div>

        <div
          className=" "
          style={{
            borderTopLeftRadius: "1rem",
            borderTopRightRadius: "1rem",
          }}
        >
          <ViewExpenseTableHR data={data} getPropertyExpense={getPropertyExpense}/>
        </div>
      </div>
    </>
  );
};

export default ViewSalaryExpenseHR;